exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-wrapper[data-v-fcfb8396]{margin-top:50px}.offset-header[data-v-fcfb8396]{top:-30px!important;margin:0 auto;max-width:calc(100% - 32px)}.header-card[data-v-fcfb8396]{top:-30px!important;margin:0 auto;max-width:calc(100% - 32px);min-height:70px;color:#fff;font-size:24px}.card-header[data-v-fcfb8396]{transition:all .3s ease-in-out}.headline[data-v-fcfb8396]{font-weight:200!important;font-size:24px!important}.hibatext-color[data-v-fcfb8396]{color:#dc1010;font-weight:700}", ""]);

// exports
